import { createAction, props } from '@ngrx/store';
import { PermanentCandidateItemModel } from 'src/app/shared/models/permanent-candidate-item.model';

export const openPermPostOfferConfirmNotStartingModalFromGrid = createAction(
    '[Perm Post Offer Confirm Not Starting Modal Component] Open Perm Offer Confirm Not Starting Modal',
    props<{ model: PermanentCandidateItemModel }>()
);

export const setJobOfferStatusToOfferAcceptedNotStartingConfirmed = createAction(
    '[Perm Offer Confirm Not Starting Modal Component] Set Job Offer Status To Confirmed Not Starting',
    props<{ jobOfferId: number }>()
);

export const setJobOfferStatusToOfferAcceptedNotStartingConfirmedSuccess = createAction(
    '[Perm Offer Confirm Not Starting Modal API] Set Job Offer Status To Confirmed Not Starting Success'
);

export const setJobOfferStatusToOfferAcceptedNotStartingConfirmedFailure = createAction(
    '[Perm Offer Confirm Not Starting Modal API] Set Job Offer Status To Confirmed Not Starting Failure',
    props<{ error: any }>()
);

export const cancelPermPostOfferConfirmNotStartingModal = createAction(
    '[Perm Offer Confirm Not Starting Modal Component] Cancel Perm Offer Confirm Not Starting Modal'
);
